import React from 'react'
import { MDBRow, MDBCol } from 'mdb-react-ui-kit'

const PrivacidadComponent = () => {
  return (
    <MDBRow
      className="ms-3 me-3"
      
      center={true}
    >
      <MDBCol
        className="col-12 text-center mb-3"
      >
      <h2>Aviso de privacidad</h2>
      </MDBCol>
      <ol>
        <p style={{textAlign: "justify"}}>
          CAJA POPULAR APASEO EL ALTO SC DE AP DE RL DE CV, mejor conocido como ALIANZA, 
          con domicilio FRANCISCO I. MADERO 403, colonia CENTRO, ciudad APASEO EL ALTO, con C.P. 38500, 
          en la entidad de GUANAJUATO, y con portal de Internet <a href="https://www.cpapaseo.com.mx/aviso-de-privacidad" target="_blank" rel="noreferrer">https://www.cpapaseo.com.mx/aviso-de-privacidad</a>, 
          es el responsable del uso y protección de sus datos personales, y al respecto le informamos lo siguiente: 
          Los datos personales recabados en el presente tramite la CAJA POPULAR APASEO EL ALTO SC DE AP DE RL DE CV . 
          Los utilizará para: Promover y proveer si es el caso, los productos y servicios de la sociedad cooperativa, Informar de nuestros productos y servicios, 
          Realizar estudios de mercadeo. Para conocer el Aviso de privacidad integral de “CAJA POPULAR APASEO EL ALTO SC DE AP DE RL DE CV”, consultar la página de Internet <a href="https://www.cpapaseo.com.mx/aviso-de-privacidad" target="_blank" rel="noreferrer">https://www.cpapaseo.com.mx/aviso-de-privacidad</a>, dar lectura al Aviso Privacidad Expuesto en la sucursal de atención o solicitar información a los teléfonos 413-166-4727/ 413-166-04 44 ext. (236).
        </p>
        
      </ol>
      <MDBCol
        className="col-12 text-center mb-3"
      >
      <h2>Terminos y condiciones</h2>
      </MDBCol>
      <ol style={{textAlign: "justify"}}>
        <li> El uso de este portal no asegura la autorización y obtención del crédito.</li>
        <li> Tu solicitud se someterá al análisis correspondiente.</li>
        <li> Al utilizar este medio de contacto, se tiene por entendido que el usuario/socio da su <strong>consentimiento</strong> para la <strong>utilización de medios electrónicos de autenticación</strong>, como lo es en este caso un nip de 4 dígitos el cual fue enviado mediante mensaje sms, y este mismo sera utilizado para expresar su consentimiento en términos y condiciones así como su <strong>consentimiento</strong> para una consulta de buró de crédito.</li>
        <li> Un ejecutivo se pondrá en contacto para darte la solución del crédito por medio de una llamada telefónica.</li>
        <li> Al ingresar su nip expresa su consentimiento para que sea consultado ante la SIC (Sociedad de Información Crediticia) asi mismo expresa su consentimiento de los terminos y condiciones de uso de este portal.</li>
        <li> El uso de este portal es únicamente de carácter informativo y de contacto.</li>
        <li> Tus datos personales deberán de estar actualizados en el Sistema de la cooperativa.</li>
        <li> El presente portal solo podrá ser utilizado para realizar una solicitud de crédito a la vez.</li>
        <li> Posterior a la presente se solicitará la autorización de buro de credito esta es necesaria para continuar con la solicitud correspondiente.</li>
        <li> El uso del nip es responsabilidad del socio.</li>
      </ol>
      
    </MDBRow>
  )
}

export default PrivacidadComponent
